import { combineReducers } from "@reduxjs/toolkit";
import apiRootSlice from "./apiSlice";

export const apiReducer = combineReducers({
  api: apiRootSlice
});